// extracted by mini-css-extract-plugin
module.exports = {"suggestion":"Suggestion_suggestion__3Ty2B","focus":"Suggestion_focus__1VLAO"};